module.exports = __webpack_public_path__ + "media/images/games/35gender/playingvideogames-eb269da42c2158b2ee24c2cfc34dfee2.png";